import { useDispatch, useSelector } from "react-redux"
import { handleGlobal } from "@/(front-desk)/store"
import { ArrowUpRightIcon } from "@heroicons/react/20/solid"
import Transition from "@/(front-desk)/components/Transition"
import classNames from "classnames"

export default function LanguageBtn() {

    const dispatch = useDispatch()
    const language = useSelector((state) => state.global).language

    return (
        <button
            className={classNames('btn-main btn-round transition', {
                'opacity-100': language,
                'opacity-0 pointer-events-none': !language
            })}
            onClick={() => {
                if (language === 'zh_hant') {
                    dispatch(handleGlobal.actions.setLanguage('en'))
                }
                else if (language === 'en') {
                    dispatch(handleGlobal.actions.setLanguage('zh_hant'))
                }
            }}
        >
            <Transition transitionKey={language}>
                {language === 'zh_hant' && 'View in English'}
                {language === 'en' && '查看中文內容'}
            </Transition>
            <ArrowUpRightIcon className="!w-5" />
        </button>
    )
}